import { Component, OnInit } from '@angular/core';
import { FieldArrayType, FormlyFormBuilder } from '@ngx-formly/core';

@Component({
    selector: 'formly-repeat-section',
    template: `
        <div *ngFor="let field of field.fieldGroup; let i = index;">
            <div class="flex justify-content-around align-items-center">
                <div class="flex-1">
                    <formly-group
                        [model]="model[i]"
                        [field]="field"
                        [options]="options"
                        [form]="formControl">
                    </formly-group>
                </div>
                <div>
                    <button pButton type="button" label="-" class="p-button-danger p-button-sm" (click)="remove(i)"></button>
                </div>

            </div>
            <hr>
        </div>
        <div class="flex justify-content-end text-center" >
            <button pButton type="button" class="p-button-sm p-button-success w-5rem" (click)="add()" label="+"></button>
        </div>
    `,
})
export class RepeatTypeComponent extends FieldArrayType {
    constructor(builder: FormlyFormBuilder) {
        super(builder);
    }
}

